import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useDebounce from './useDebounce';

export default function useSearch(debounceDelay = 0) {
  const [params] = useSearchParams();
  const [search, setSearch] = useState('');

  const debounce = useDebounce(search, debounceDelay);

  useEffect(() => {
    const searchParam = params.get('search');
    setSearch(searchParam || '');
  }, [params]);

  return debounce;
}

export function useSearchUpdate() {
  const [params, setParams] = useSearchParams();
  const [search, setSearch] = useState('');

  const updateSearch = (newSearch) => {
    setParams((prev) => {
      const nextParams = new URLSearchParams(prev);
      const normalizedSearch = typeof newSearch === 'string' ? newSearch : '';

      if (normalizedSearch) {
        nextParams.set('search', normalizedSearch);
      } else {
        nextParams.delete('search');
      }

      return nextParams;
    });
  };

  useEffect(() => {
    setSearch(params.get('search'));
  }, [params]);

  return [search, updateSearch];
}
